import React from 'react'
import Modal from 'react-modal'
import CloseIcon from 'react-icons/lib/fa/close'
import labels from '../../data/labels.json'

import ReservationForm from '../MainForm'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
}

class FleetModal extends React.Component {
  constructor() {
    super()
    this.state = {
      modalIsOpen: false,
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }
  openModal() {
    this.setState({ modalIsOpen: true })
  }
  closeModal() {
    this.setState({ modalIsOpen: false })
  }

  render() {
    return (
      <div>
        <a onClick={this.openModal} className="btn">
          {labels.reserve[this.props.lang]}
        </a>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Get a Quick Quote"
        >
          <div className="close">
            <a href="#" onClick={this.closeModal}>
              <CloseIcon />
            </a>
          </div>
          <div className="form-modal">
            <ReservationForm couponCode={this.props.couponCode} lang={this.props.lang} />
          </div>
        </Modal>
      </div>
    )
  }
}

export default FleetModal



// WEBPACK FOOTER //
// ./src/components/Fleet/FleetModal.js